import { useCallback, useEffect, useState } from "react";
import { api } from "./api";
import { AuthScreen } from "./components/AuthScreen";
import { Cabinet } from "./components/Cabinet";
import { PublicHome } from "./components/PublicHome";
import type { User } from "./types";

export function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [path, setPath] = useState(window.location.pathname);

  const refreshSession = useCallback(async () => {
    try {
      const session = await api.me();
      setUser(session.user);
      return session;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void refreshSession(); }, [refreshSession]);
  useEffect(() => {
    const update = () => setPath(window.location.pathname);
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);

  const navigate = useCallback((nextPath: string) => {
    window.history.pushState({}, "", nextPath);
    setPath(nextPath);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  async function logout() {
    await api.logout().catch(() => undefined);
    setUser(null);
    navigate("/");
  }

  const protectedRoute = path.startsWith("/cabinet");
  const authRoute = path === "/login" || path === "/reset-password";
  const onAuthenticated = async () => {
    await refreshSession();
    navigate("/cabinet");
  };

  if (loading && (protectedRoute || authRoute)) return <main className="loading-screen"><div className="loader-mark">PS</div><p>Открываю личный кабинет…</p></main>;
  if (authRoute) return <AuthScreen onBack={() => navigate("/")} onAuthenticated={onAuthenticated} />;
  if (!protectedRoute) return <PublicHome user={user} onNavigate={navigate} />;
  if (!user) return <AuthScreen onBack={() => navigate("/")} onAuthenticated={onAuthenticated} />;
  return <Cabinet user={user} section={path === "/cabinet/settings" ? "settings" : "journal"} onNavigate={navigate} onLogout={logout} />;
}
